import { createAsyncThunk } from '@reduxjs/toolkit';
import jobTypeApi from '~/apis/jobType';
import {
  CREATE_JOB_TYPES,
  EDIT_JOB_TYPES,
  GET_JOB_TYPE,
  GET_JOB_TYPES,
  GET_JOB_TYPES_LIST,
} from '~/utils/constants/actionType';
import {
  IJobType,
  IJobTypeCreate,
  IParamsGetJobType,
  IResponseGetJobType,
  IResponseGetJobTypes,
} from '~/utils/interface/jobType';

export const handleGetJobTypes = createAsyncThunk<IResponseGetJobTypes>(
  GET_JOB_TYPES,
  async (_params, { rejectWithValue }) => {
    try {
      const res = await jobTypeApi.getJobTypes();

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetJobListTypes = createAsyncThunk<IResponseGetJobType, IParamsGetJobType>(
  GET_JOB_TYPES_LIST,
  async (params: IParamsGetJobType = {}, { rejectWithValue }) => {
    try {
      const res = await jobTypeApi.getJobListTypes(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateJobType = createAsyncThunk<null, IJobTypeCreate>(
  CREATE_JOB_TYPES,
  async (data: IJobTypeCreate, { rejectWithValue }) => {
    try {
      const res = await jobTypeApi.create(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleEditJobType = createAsyncThunk<IJobType, { id: string; params: IJobTypeCreate }>(
  EDIT_JOB_TYPES,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await jobTypeApi.update(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetJobType = createAsyncThunk<IJobType, string>(
  GET_JOB_TYPE,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await jobTypeApi.getDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
